<template>
    <div class="retailers-map">
        
        <div class="retailers-map__results-map" />
    </div>
</template>

<script>
/*
global google
*/
import {store} from '../store';

export default {
    name: 'RetailersMap',
    props: {
        apiKey: {
            type: String,
            required: true,
        },
        mapHeight: {
            type: String,
            required: false,
            default: '100vh', // 400,
        },
    },
    data: () => {
        return {
            sharedStore: store.state,
            map: false,
            mapElement: false,
        };
    },
    watch: {
        'sharedStore.retailers': 'showMap',
    },
    mounted() {
        // do NOT use an arrow function here
        var app = this;

        app.mapElement = app.$el.querySelector('.retailers-map__results-map');
        app.$el.style.height = app.mapElement.style.height = '0';

        const mapsScriptBaseUrl = 'https://maps.googleapis.com/maps/api/js?libraries=places';
        const mapsScriptUrl = mapsScriptBaseUrl + '&key=' + app.apiKey;

        if (typeof window.google !== 'undefined') {
            app.setup();
        } else {
            var mapsApiScript = document.querySelector('script[src^="' + mapsScriptBaseUrl + '"]');

            if (!mapsApiScript) {
                mapsApiScript = document.createElement('script');
                mapsApiScript.id = 'google-maps-api';
                mapsApiScript.async = true;

                mapsApiScript.onload = () => {
                    app.setup();
                };

                mapsApiScript.onerror = e => {
                    app.emitEvent('maps-api-script-load-error', 'unable to load google api script. google geolocation api unavailable.', e);
                    app.store.loading = false;
                    app.$el.style.height = app.mapElement.style.height = '0';
                };

                mapsApiScript.setAttribute('src', mapsScriptUrl);
                document.head.appendChild(mapsApiScript);
            }
        }
    },

    methods: {
        setup() {
            var googleMapsAvailable = typeof window.google !== 'undefined' && window.google.maps && window.google.maps.places;

            if (!googleMapsAvailable) {
                console.error('google geolocation api unavailable');
                console.warn('fdsa');
                return;
            }

            this.showMap();
        },
        showMap() {
            if (!this.$el || !this.$el.children) {
                return;
            }
            
            if (!this.mapElement) {
                this.mapElement = this.$el.querySelector('.retailers-map__results-map');
            }

            if (!this.mapElement) {
                return;
            }

            var data = this.sharedStore;
            
            if (data.searched && (!data.retailers || data.retailers.length === 0)) {
                this.$el.style.height = this.mapElement.style.height = 0;
                return;
            }
            
            // v-show="sharedStore.searched && (!sharedStore.retailers || sharedStore.retailers.length == 0)"

            this.mapElement.style.height = this.$el.style.height = this.mapHeight;

            var originCoords = {lat: data.location.latitude, lng: data.location.longitude};
            var mapInfoBubble = new window.google.maps.InfoWindow();
            var bounds = new window.google.maps.LatLngBounds();
            
            this.map = new window.google.maps.Map(this.mapElement, {
                center: originCoords,
                zoom: 11,
                disableDefaultUI: true,
                gestureHandling: 'none',
                scaleControl: true,
                zoomControl: true,
            });
            

            var originPositionMarker = new window.google.maps.Marker({
                position: originCoords,
                map: this.map,
                title: 'You are here.',
            });

            // update the map's bounds to show the origin marker
            bounds.extend(originPositionMarker.getPosition());

            window.google.maps.event.addListener(this.map, 'click', function() {
                mapInfoBubble.close();
            });

            for (var i = 0; i < data.retailers.length; i++) {
                const retailer = data.retailers[i];

                var coords = {lat: Number(retailer.dealership.latitude), lng: Number(retailer.dealership.longitude)};
                var marker = new window.google.maps.Marker({
                    position: coords,
                    map: this.map,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 5,
                        fillColor: '#750F2C',
                        strokeColor: '#750F2C',
                    },
                    title: retailer.dealership.dealerName,
                    retailer: retailer,
                });

                // update the map's bounds to show this marker
                bounds.extend(marker.getPosition());

                google.maps.event.addListener(marker, 'click', function() {
                    mapInfoBubble.setContent(`<b>${retailer.dealership.dealerName}</b><br /><a href="${retailer.dealership.dealershipAttributes.website}">WEBSITE</a><br />${retailer.dealership.shippingPhone}`);
                    mapInfoBubble.open(this.map, this);
                });
            }

            // update the map so it shows all markers
            this.map.fitBounds(bounds);
        },
        emitEvent: function(eventName, message, error) {
            let eventObject = {
                eventName: 'event',
                eventGlobalName: 'retailers-map',
                message: message || '',
            };

            if (error) {
                eventObject.error = error;
            }

            if (eventName && eventName.length > 0) {
                eventObject.eventName = eventName.toLowerCase().replace(/[\W]{1,}/gi, '-');
            }

            eventObject.eventGlobalName += '-' + eventObject.eventName;

            this.$emit(eventObject.eventName, eventObject);

            this.$root.$emit(eventObject.eventGlobalName, eventObject);

            document.dispatchEvent(new CustomEvent(eventObject.eventGlobalName, eventObject));

            if ((error && typeof error !== 'undefined' && error !== null) || message.indexOf('error') > -1) {
                console.error(message, error);
            }
        },

        trackClick(retailer, actionMessage) {
            if (window.gtag) {
                window.gtag('event', 'retailer-external-link', {event_category: actionMessage, event_label: retailer.name + ' - ' + retailer.id});
            }

            // if (window.dataLayer) {
            //     // google tag manager
            //     window.dataLayer.push({
            //         event: 'retailer-external-link',
            //         action: actionMessage,
            //         'results-found': retailer.name + ' - ' + retailer.id,
            //     });
            // } else if (window.ga) {
            //     // google analytics
            //     window.ga('send', 'event', 'retailer-external-link', actionMessage, retailer.name + ' - ' + retailer.id);
            // }
        },
    },
};
</script>

<style lang="scss">
.retailers-map {
    transition: height 0.3s ease-out;
}
.retailers-map,
.retailers-map__results-map {
    margin: 0 auto;
    height: 0; //set by code above
    //max-width: 800px;
}
</style>
